module.exports = __webpack_public_path__ + "img/dragon-left.d7916f93.png";